
  export default {
    props: {
      articles: {
        type: Array,
        default: () => ([])
      }
    },
    computed: {
      author () {
        return this.$store.getters['blog/getAuthor'];
      },
      count () {
        const first = ((this.pagination.page - 1) * this.pagination['per-page']) + 1;
        return this.$t('count', {
          first: this.$n(first),
          last: this.$n(Math.min(this.pagination.records, first + this.pagination['per-page'] - 1)),
          total: this.$n(this.pagination.records)
        });
      },
      meta () {
        return this.$store.getters['blog/getMeta'];
      },
      pagination () {
        return this.$store.getters['utils/getPagination'];
      }
    }
  };
